import { ActorFilterRegistryCategory } from '../ActorFilterRegistryCategory';
import { ActorFilterRegistryItem } from '../ActorFilterRegistryItem';
import { runtime } from '../../../classes/runtime/Runtime';
import { QuestionTypeName } from '../../../classes/learnware/LearnwareEnums';
export class ActorFilterQuestion extends ActorFilterRegistryCategory {
    label = 'Question';
    constructor(parent) {
        super(parent);
        Object.values(QuestionTypeName).forEach(qt => {
            this[`questionOfType_${qt}`] = () => new ActorFilterRegistryItem({
                label: `Question instanceof ${qt}`,
                filter: ({ a }) => !!runtime.class[`Question${qt}`] && a instanceof runtime.class[`Question${qt}`]
            });
        });
        super.init();
    }
    questionPart_text = () => new ActorFilterRegistryItem({
        label: 'QuestionPart > Text',
        filter: ({ a }) => a instanceof runtime.class.AttachedText && a.context.parentActor.type === 'questionpart'
    });
    questionPart_image = () => new ActorFilterRegistryItem({
        label: 'QuestionPart > Image',
        filter: ({ a }) => a instanceof runtime.class.AttachedImage && a.context.parentActor.type === 'questionpart'
    });
}
